import React from 'react'

export const SvgBottom = () => {
    return (
        <>
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px"
                y="0px" viewBox="0 109.091 1280 133.909" enableBackground="new 0 109.091 1280 133.909" >
                <path className="shodow_bottom" fill="rgb(224, 224, 224)" d="M1280.001,185.914c0,0-341.217-82.661-557.527-30.328c0,0-226.499,55.514-351.788,67.071 c0,0-104.53,18.389-370.686-11.875V109.091l1280.001,0.001V185.914z" />
            </svg>
        </>
    )
}
